export class InvoicingServiceData {
  serviceConceptId: number;
  serviceConceptName: string;
  serviceDays: ServiceDayData[]
}

export class ServiceDayData {
  day: number;
  amount: number;
  isHoliday: boolean;
  updated: boolean;
}